import { useMemo } from '@wordpress/element';
import { useContextSystem } from '../../context';
import * as styles from '../styles';
import { useCx } from '../../utils/hooks/use-cx';
export function useCardFooter(props) {
  const {
    className,
    justify,
    isBorderless = false,
    isShady = false,
    size = 'medium',
    ...otherProps
  } = useContextSystem(props, 'CardFooter');
  const cx = useCx();
  const classes = useMemo(() => {
    return cx(styles.getCardFooterStyles({
      isBorderless,
      isShady,
      size
    }),
    // This classname is added for legacy compatibility reasons.
    'components-card__footer', className);
  }, [className, cx, isBorderless, isShady, size]);
  return {
    ...otherProps,
    className: classes,
    justify
  };
}